<template>
  <div>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <b-row>
      <base-calendar
        ref="baseCalendar"
        class="calendar align-top d-inline-block p-2"
        :dateStr.sync="calendarDate"
        @onMounted="onCalendarMounted"
      />

      <b-col>
        <b-row style="width: 100%; display: flex; justify-content: flex-end">
          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardPlanoViagem')"
            :class="{ 'selected-card': selectedCard === 'cardPlanoViagem' }"
          >
            <a
              href=""
              @click.prevent="toggleStatusNameFilter('Plano de Viagem')"
            >
              <div class="dashboard-indicator-2 status-iddle">
                <p
                  class="dashboard-indicator-title"
                  style="color: black !important"
                >
                  {{ dashboard.tripsPlanoViagem }}
                </p>
                <p
                  class="dashboard-indicator-category"
                  style="color: black !important"
                >
                  Plano de viagem
                </p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardAguardandoAceite')"
            :class="{
              'selected-card': selectedCard === 'cardAguardandoAceite',
            }"
          >
            <a
              href=""
              @click.prevent="toggleStatusNameFilter('Aguardando Aceite')"
            >
              <div class="dashboard-indicator-2 status-pending">
                <p
                  class="dashboard-indicator-title"
                  style="color: black !important"
                >
                  {{ dashboard.tripsAguardandoAceite }}
                </p>
                <p
                  class="dashboard-indicator-category"
                  style="color: black !important"
                >
                  Aguardando aceite
                </p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardPendentes')"
            :class="{ 'selected-card': selectedCard === 'cardPendentes' }"
          >
            <a href="" @click.prevent="toggleApenasDocumentacaoPendente()">
              <div class="dashboard-indicator-2 status-purple">
                <p class="dashboard-indicator-title">
                  {{ dashboard.documentsProblemsDay }}
                </p>
                <p class="dashboard-indicator-category">Docs. pendentes</p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardChecklistPendentes')"
            :class="{
              'selected-card': selectedCard === 'cardChecklistPendentes',
            }"
          >
            <a href="" @click.prevent="toggleApenasChecklistsGrisPendente()">
              <div class="dashboard-indicator-2 status-problem">
                <div
                  :class="
                    dashboard.checklistsGrisProblemTotal > 0
                      ? 'dashboard-indicator-2 alert-checklist-gris'
                      : ''
                  "
                >
                  <p class="dashboard-indicator-title">
                    {{ dashboard.checklistsGrisProblem }}
                  </p>
                  <p class="dashboard-indicator-category">
                    Checklist pendentes
                  </p>
                </div>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardValidacaoLiberacao')"
            :class="{
              'selected-card': selectedCard === 'cardValidacaoLiberacao',
            }"
          >
            <a
              href=""
              @click.prevent="toggleStatusNameFilter('Validação/Liberação GR')"
            >
              <div class="dashboard-indicator-2 status-validation">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsValidacaoLiberacaoGR }}
                </p>
                <p class="dashboard-indicator-category">
                  {{ "Validação / Liberação GR" }}
                </p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardCarregamento')"
            :class="{ 'selected-card': selectedCard === 'cardCarregamento' }"
          >
            <a
              href=""
              @click.prevent="toggleStatusNameFilter('Em Carregamento')"
            >
              <div class="dashboard-indicator-2 status-blue">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsCarregamento }}
                </p>
                <p class="dashboard-indicator-category">Em carregamento</p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardEspera')"
            :class="{ 'selected-card': selectedCard === 'cardEspera' }"
          >
            <a href="" @click.prevent="toggleStatusNameFilter('Em Espera')">
              <div class="dashboard-indicator-2 status-orange">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsEmEspera }}
                </p>
                <p class="dashboard-indicator-category">Em espera</p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardDescarga')"
            :class="{ 'selected-card': selectedCard === 'cardDescarga' }"
          >
            <a href="" @click.prevent="toggleStatusNameFilter('Em Descarga')">
              <div class="dashboard-indicator-2 status-orange">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsEmDescarga }}
                </p>
                <p class="dashboard-indicator-category">Em descarga</p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardInicioViagem')"
            :class="{ 'selected-card': selectedCard === 'cardInicioViagem' }"
          >
            <a
              href=""
              @click.prevent="toggleStatusNameFilter('Inicio de Viagem')"
            >
              <div class="dashboard-indicator-2 status-ok">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsInicioViagem }}
                </p>
                <p class="dashboard-indicator-category">Inicio de viagem</p>
              </div>
            </a>
          </div>

          <div
            sm="1"
            class="dashboard-indicator-1"
            @click="selectCard('cardFimViagem')"
            :class="{ 'selected-card': selectedCard === 'cardFimViagem' }"
          >
            <a href="" @click.prevent="toggleStatusNameFilter('Fim de Viagem')">
              <div class="dashboard-indicator-2 status-ok">
                <p class="dashboard-indicator-title">
                  {{ dashboard.tripsFimViagem }}
                </p>
                <p class="dashboard-indicator-category">Fim de viagem</p>
              </div>
            </a>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <div v-if="isLoadingPage">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <b-row v-else>
      <b-table
        ref="table"
        class="table-nowrap shLogStatusTrip"
        :items="tableRows"
        :fields="fields"
        :filter="tableFilters"
        striped
        hover
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="field.type == 'date'">
                <b-form-input
                  class="dateIndividual"
                  type="date"
                  v-model="tableFilters[field.key]"
                  :debounce="tableFilterDebounce"
                  v-on:update="applyFilter"
                />
              </div>
              <div v-else-if="field.key == 'statusName'">
                <single-select
                  :value.sync="tableFilters.statusName"
                  :value-property="'value'"
                  :options="tripsStages"
                  :debounce="tableFilterDebounce"
                  v-on:update="applyFilter"
                />
              </div>
              <div v-else-if="field.key == 'checklistGrisPadraoStatus'">
                <single-select
                  :value.sync="tableFilters.checklistGrisPadraoStatus"
                  :value-property="'value'"
                  :options="optionsChecklistGrisPadraoStatus"
                  :debounce="tableFilterDebounce"
                  v-on:update="applyFilter"
                />
              </div>
              <div v-else-if="field.key == 'documentacao'">
                <single-select
                  :value.sync="tableFilters.documentacao"
                  :value-property="'value'"
                  :options="optionsDocumentacao"
                  :debounce="tableFilterDebounce"
                  v-on:update="applyFilter"
                />
              </div>
              <div v-else>
                <b-form-input
                  v-model="tableFilters[field.key]"
                  :debounce="tableFilterDebounce"
                  v-on:update="applyFilter"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell()="cell">
          <div v-if="cell.field.key == 'id'">
            <a
              href="#"
              @click.prevent="
                $refs.fillingDetails.show(
                  cell.value,
                  cell.item.stageId,
                  cell.item.CanComment == 'True'
                )
              "
            >
              # <u>{{ cell.value }}</u>
            </a>
          </div>
          <div
            v-else-if="cell.field.key == 'checklistGrisPadraoStatus'"
            :class="ClassChecklistPadraoColor(cell.item)"
          >
            {{ cell.value }}
          </div>
          <div
            v-else-if="cell.field.key == 'documentacao'"
            :class="ClassDocumentColor(cell.item)"
          >
            {{ cell.value }}
          </div>
          <div v-else-if="cell.field.key == 'motorista'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div v-else-if="cell.field.key == 'responsavelAcompanhamento'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div v-else-if="cell.field.key == 'rotaNome'">
            <div class="td-limitado">
              {{ cell.value }}
            </div>
          </div>
          <div
            v-else-if="cell.field.key == 'statusName'"
            :class="classStatusNameColor(cell.item)"
          >
            {{ cell.value }}
          </div>
          <div v-else>
            {{ cell.value }}
          </div>
        </template>

        <template v-slot:cell(motorista)="data">
          <b-row>
            <b-col class="mt-1" cols="9">
              {{ data.item.motorista }}
            </b-col>
            <b-col v-if="data.item.occurrenceDriver != '0'" class="icons_div">
              <a
                class="icon_style"
                href="#"
                @click.prevent="
                  openWorkflowOccurrecesFilledModal(
                    data.item.driverValueId,
                    data.item.motorista
                  )
                "
              >
                <u>
                  <i class="material-icons">report</i>
                </u>
              </a>
            </b-col>
          </b-row>
        </template>

        <template v-slot:cell(placa)="data">
          <b-row>
            <b-col cols="6" class="mt-1">
              {{ data.item.placa }}
            </b-col>
            <b-col v-if="data.item.occurrenceVehicle != '0'" cols="1">
              <a
                class="icon_style"
                href="#"
                @click.prevent="
                  openWorkflowOccurrecesFilledModal(
                    data.item.vehicleValueId,
                    data.item.placa
                  )
                "
              >
                <u>
                  <i class="material-icons">report</i>
                </u>
              </a>
            </b-col>
          </b-row>
        </template>
      </b-table>

      <div v-show="isBusy" class="text-center my-2" style="width: 100%">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </b-row>
    <workflow-occurreces-filled-modal ref="WorkflowOccurrecesFilledModal" />

    <filling-details-modal
      ref="fillingDetails"
      :processName="'Programação'"
      :permissions="permissions"
    />
  </div>
</template>
<script>
export default {
  name: "ShlogTripStatusList",
  components: {
    BaseCalendar: () => import("@/components_rms/base/BaseCalendar.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    FillingDetailsModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/FillingDetailsModal.vue"
      ),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    WorkflowOccurrecesFilledModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowOccurrecesFilledModal.vue"
      ),
    // TablePaginationProps: () =>
    //   import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      audio: null,
      calendarDate: null,
      dashboard: {
        checklistsGrisProblem: 0,
        checklistsGrisProblemTotal: 0,
        documentsProblemsDay: 0,
        documentsProblemsTotal: 0,
        isLoadingChecklistProblems: false,
        tripsPlanoViagem: 0,
        tripsAguardandoAceite: 0,
        tripsDocumentos: 0,
        tripsValidacaoLiberacaoGR: 0,
        tripsInicioViagem: 0,
        tripsFimViagem: 0,
        tripsCarregamento: 0,
        tripsEmEspera: 0,
        tripsEmDescarga: 0,
      },
      fields: [
        {
          key: "id",
          filterKey: "id",
          label: "Id",
          thStyle: "width: 100px;",
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "dataInicio",
          filterKey: "dataInicio",
          label: "Data de início",
          type: "date",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "dataPrazo",
          filterKey: "dataPrazo",
          label: "Data de prazo",
          type: "date",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "rotaNome",
          filterKey: "rotaNome",
          label: "Rota",
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "motorista",
          filterKey: "motorista",
          label: "Motorista",
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "placa",
          filterKey: "placa",
          label: "Placa",
          thStyle: "width: 140px;",
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "responsavelAcompanhamento",
          filterKey: "responsavelAcompanhamento",
          label: "Responsável Acompanhamento",
          thStyle: "text-align: center; width: 130px;",
          tdAttr: this.cellsColorAttr,
        },
        {
          key: "statusName",
          filterKey: "statusName",
          label: "Etapa",
          thStyle: "text-align: center; width: 180px;",
        },
        {
          key: "documentacao",
          filterKey: "documentacao",
          label: "Documentação",
          thStyle: "text-align: center; width: 180px;",
        },
        {
          key: "checklistGrisPadraoStatus",
          filterKey: "checklistGrisPadraoStatus",
          label: "Checklist GRIS",
          thStyle: "text-align: center; width: 120px;",
        },
      ],
      permissions: null,
      process: [],
      selectedCard: null,
      isBusy: false,
      isLoadingPage: true,
      tableFilters: {
        apenasChecklistGrisPendente: false,
        apenasDocumentacaoPendente: false,
        apenasViagensEmAndamento: false,
        id: null,
        dateCreate: "",
        dateChange: "",
        dataInicioBegin: null,
        dataInicioEnd: null,
        dataInicio: "",
        dataPrazo: "",
        statusId: "",
        statusName: "",
        userName: "",
        allowComments: null,
        active: null,
        rotaNome: null,
        motorista: "",
        placa: "",
        carreta1: "",
        carreta2: "",
        emiteCte: null,
        cte: null,
        documentacao: "",
        precisaGris: null,
        checklistGrisPadraoId: null,
        checklistGrisPadraoStatus: "",
        responsavelAcompanhamento: "",
      },
      tableFilterDebounce: 2000,
      allInformations: [],
      tableRows: [],
      tableRowCount: 0,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableSelectMode: "single",
      tableSelectedItem: [],
      timmer: null,
      tripsStages: [
        { value: "Plano de Viagem", text: "Plano de Viagem" },
        { value: "Aguardando Aceite", text: "Aguardando Aceite" },
        { value: "Documentos", text: "Documentos" },
        { value: "Validação/Liberação GR", text: "Validação/Liberação GR" },
        { value: "Em Carregamento", text: "Em Carregamento" },
        { value: "Em Espera", text: "Em Espera" },
        { value: "Em Descarga", text: "Em Descarga" },
        { value: "Inicio de Viagem", text: "Inicio de Viagem" },
        { value: "Fim de Viagem", text: "Fim de Viagem" },
      ],
      optionsChecklistGrisPadraoStatus: [
        { value: "OK", text: "OK" },
        { value: "Em rascunho", text: "Em Rascunho" },
      ],
      optionsDocumentacao: [
        { value: "OK", text: "OK" },
        { value: "Pendente", text: "Pendente" },
      ],
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.audio != null) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.updateTable();
      if (this.dashboard.checklistsGrisProblemTotal > 0) {
        this.alarmPlay();
      }
    }, 30000);
    this.getPermissions();
  },
  methods: {
    // Atualiza os dados da tabela sem desaparecer da tela
    async updateTable() {
      const newData = await this.myProvider();
      this.tableRows = newData;
    },
    // Método chamado sempre que um filtro é alterado
    applyFilter() {
      this.tableRows = [];
      this.myProvider().then((newData) => {
        this.tableRows = newData;
      });
    },
    async myProvider() {
      try {
        this.isBusy = true;
        this.alarmStop();
        this.dashboard.checklistsGrisProblem = 0;
        this.dashboard.checklistsGrisProblemTotal = 0;
        this.dashboard.documentsProblemsDay = 0;
        this.dashboard.tripsPlanoViagem = 0;
        this.dashboard.tripsAguardandoAceite = 0;
        this.dashboard.tripsDocumentos = 0;
        this.dashboard.tripsValidacaoLiberacaoGR = 0;
        this.dashboard.tripsInicioViagem = 0;
        this.dashboard.tripsFimViagem = 0;
        this.dashboard.tripsCarregamento = 0;
        this.dashboard.tripsEmEspera = 0;
        this.dashboard.tripsEmDescarga = 0;

        const filters = this.createFilters();
        const url = this.createUrlList(filters);
        const response = await this.$apiWorkflow.get(url);
        const items = response.data;

        this.tableRowCount = items.length;
        this.isBusy = false;

        for (let trip of items) {
          this.countDashboard(trip);
        }
        if (this.dashboard.checklistsGrisProblemTotal > 0) {
          // ivan
          this.alarmPlay();
        }
        return items;
      } catch (error) {
        console.log("Error");
        console.log(error);
        console.log(error.response);
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.alert.error = error.message;
          this.$refs.danger.show();
          this.isBusy = false;
          this.tableRowCount = 0;
        }
        return [];
      }
    },
    countDashboard(trip) {
      if (this.isChecklistPending(trip)) {
        this.dashboard.checklistsGrisProblem++;
      } // ivan
      if (this.isChecklistGrisMustAttention(trip)) {
        this.dashboard.checklistsGrisProblemTotal++;
      }
      if (this.isDocumentacaoPending(trip)) {
        this.dashboard.documentsProblemsDay++;
      }
      switch (trip.statusName.toUpperCase()) {
        case "FIM DE VIAGEM":
          this.dashboard.tripsFimViagem++;
          break;
        case "INICIO DE VIAGEM":
          this.dashboard.tripsInicioViagem++;
          break;
        case "PLANO DE VIAGEM":
          this.dashboard.tripsPlanoViagem++;
          break;
        case "AGUARDANDO ACEITE":
          this.dashboard.tripsAguardandoAceite++;
          break;
        case "DOCUMENTOS":
          this.dashboard.tripsDocumentos++;
          break;
        case "VALIDAÇÃO/LIBERAÇÃO GR":
          this.dashboard.tripsValidacaoLiberacaoGR++;
          break;
        case "EM CARREGAMENTO":
          this.dashboard.tripsCarregamento++;
          break;
        case "EM ESPERA":
          this.dashboard.tripsEmEspera++;
          break;
        case "EM DESCARGA":
          this.dashboard.tripsEmDescarga++;
          break;
      }
    },
    createFilters() {
      const filters = {
        apenasChecklistGrisPendente:
          this.tableFilters.apenasChecklistGrisPendente,
        apenasDocumentacaoPendente:
          this.tableFilters.apenasDocumentacaoPendente,
        apenasViagensEmAndamento: this.tableFilters.apenasViagensEmAndamento,
        id: this.tableFilters.id,
        dateCreate: this.tableFilters.dateCreate,
        dateChange: this.tableFilters.dateChange,
        dataInicioBegin: this.tableFilters.dataInicioBegin,
        dataInicioEnd: this.tableFilters.dataInicioEnd,
        dataInicio: this.tableFilters.dataInicio,
        dataPrazo: this.tableFilters.dataPrazo,
        statusId: this.tableFilters.statusId,
        statusName: this.tableFilters.statusName,
        userName: this.tableFilters.userName,
        allowComments: this.tableFilters.allowComments,
        active: this.tableFilters.active,
        rotaNome: this.tableFilters.rotaNome,
        motorista: this.tableFilters.motorista,
        placa: this.tableFilters.placa,
        carreta1: this.tableFilters.carreta1,
        carreta2: this.tableFilters.carreta2,
        emiteCte: this.tableFilters.emiteCte,
        cte: this.tableFilters.cte,
        documentacao: this.tableFilters.documentacao,
        precisaGris: this.tableFilters.precisaGris,
        checklistGrisPadraoId: this.tableFilters.checklistGrisPadraoId,
        checklistGrisPadraoStatus: this.tableFilters.checklistGrisPadraoStatus,
        responsavelAcompanhamento: this.tableFilters.responsavelAcompanhamento,
      };
      return filters;
    },
    appendFiltersOnUrl(url, filters) {
      if (filters.apenasChecklistGrisPendente) {
        url += `apenasChecklistGrisPendente=${filters.apenasChecklistGrisPendente}&`;
      }
      if (filters.apenasDocumentacaoPendente) {
        url += `apenasDocumentacaoPendente=${filters.apenasDocumentacaoPendente}&`;
      }
      if (filters.apenasViagensEmAndamento) {
        url += `apenasViagensEmAndamento=${filters.apenasViagensEmAndamento}&`;
      }
      if (filters.dataInicioBegin != null && filters.dataInicioBegin != "") {
        url += `dataInicioBegin=${filters.dataInicioBegin}&`;
      }
      if (filters.dataInicioEnd != null && filters.dataInicioEnd != "") {
        url += `dataInicioEnd=${filters.dataInicioEnd}&`;
      }
      if (filters.id != null && filters.id != "") {
        url += `id=${filters.id}&`;
      }
      if (filters.dateCreate != null && filters.dateCreate != "") {
        url += `dateCreate=${filters.dateCreate}&`;
      }
      if (filters.dateChange != null && filters.dateChange != "") {
        url += `dateChange=${filters.dateChange}&`;
      }
      if (filters.statusName != null && filters.statusName != "") {
        url += `statusName=${filters.statusName}&`;
      }
      if (filters.userName != null && filters.userName != "") {
        url += `userName=${filters.userName}&`;
      }
      if (filters.allowComments != null && filters.allowComments != "") {
        url += `allowComments=${filters.allowComments}&`;
      }
      if (filters.active != null && filters.active != "") {
        url += `active=${filters.active}&`;
      }
      if (filters.dataInicio != null && filters.dataInicio != "") {
        url += `dataInicioEquals=${filters.dataInicio}&`;
      }
      if (filters.dataPrazo != null && filters.dataPrazo != "") {
        url += `dataPrazoEquals=${filters.dataPrazo}&`;
      }
      if (filters.rotaNome != null && filters.rotaNome != "") {
        url += `rotaNome=${filters.rotaNome}&`;
      }
      if (filters.motorista != null && filters.motorista != "") {
        url += `motorista=${filters.motorista}&`;
      }
      if (filters.placa != null && filters.placa != "") {
        url += `placa=${filters.placa}&`;
      }
      if (filters.placa != null && filters.placa != "") {
        url += `placa=${filters.placa}&`;
      }
      if (filters.carreta1 != null && filters.carreta1 != "") {
        url += `carreta1=${filters.carreta1}&`;
      }
      if (filters.carreta2 != null && filters.carreta2 != "") {
        url += `carreta2=${filters.carreta2}&`;
      }
      if (filters.emiteCte != null && filters.emiteCte != "") {
        url += `emiteCte=${filters.emiteCte}&`;
      }
      if (filters.cte != null && filters.cte != "") {
        url += `cte=${filters.cte}&`;
      }
      if (filters.documentacao != null && filters.documentacao != "") {
        url += `documentacao=${filters.documentacao}&`;
      }
      if (
        filters.checklistGrisPadraoStatus != null &&
        filters.checklistGrisPadraoStatus != ""
      ) {
        url += `checklistGrisPadraoStatus=${filters.checklistGrisPadraoStatus}&`;
      }
      if (filters.precisaGris != null && filters.precisaGris != "") {
        url += `precisaGris=${filters.precisaGris}&`;
      }
      if (
        filters.checklistGrisPadraoId != null &&
        filters.checklistGrisPadraoId != ""
      ) {
        url += `checklistGrisPadraoId=${filters.checklistGrisPadraoId}&`;
      }
      if (
        filters.responsavelAcompanhamento != null &&
        filters.responsavelAcompanhamento != ""
      ) {
        url += `responsavelAcompanhamento=${filters.responsavelAcompanhamento}&`;
      }
      return url.substring(0, url.length - 1);
    },
    createUrlCount(filters) {
      var url = "/shlog/trip/status/count?";
      url = this.appendFiltersOnUrl(url, filters);
      return url;
    },
    createUrlList(filters) {
      var url = "/shlog/trip/status/list?";
      url = this.appendFiltersOnUrl(url, filters);
      return url;
    },
    onCalendarMounted() {
      this.$refs["baseCalendar"].setToday();
      this.isLoadingPage = false;
    },
    statusColorAttr(value, key, item) {
      return this.statusColorStyle(item);
    },
    getDataNecessidadeGris() {
      const now = this.getDateTimeNow();
      // const dataNecessidadeGris = new Date("2024-01-06T15:50:00");
      const dataNecessidadeGris = this.addHours(now, 3);
      return dataNecessidadeGris;
    },
    getPermissions() {
      const workflowProcessId = 13;
      this.$apiWorkflow
        .get(`/customFilter/GetPerimissions/${workflowProcessId}`)
        .then((response) => {
          this.permissions = response.data;
        });
    },
    isChecklistGrisMustAttention(trip) {
      if (!this.isChecklistPending(trip)) {
        return false;
      }
      const dataNecessidadeGris = this.getDataNecessidadeGris();
      const dataInicio = new Date(trip.dataInicio);
      if (dataInicio < dataNecessidadeGris) {
        return true;
      } else {
        return false;
      }
    },
    isChecklistPending(trip) {
      switch (trip.statusName.toUpperCase()) {
        case "PLANO DE VIAGEM":
          return false;
        case "INICIO DE VIAGEM":
          return false;
        case "FIM DE VIAGEM":
          return false;
      }
      switch (trip.checklistGrisPadraoStatus) {
        case "OK":
          return false;
      }
      return true;
    },
    isDocumentacaoPending(trip) {
      return trip.documentacao.toUpperCase() != "OK";
    },
    toggleApenasChecklistsGrisPendente() {
      this.tableFilters.apenasChecklistGrisPendente =
        !this.tableFilters.apenasChecklistGrisPendente;
    },
    toggleApenasDocumentacaoPendente() {
      this.tableFilters.apenasDocumentacaoPendente =
        !this.tableFilters.apenasDocumentacaoPendente;
    },
    toggleStatusNameFilter(statusName) {
      if (this.tableFilters.statusName == statusName) {
        this.tableFilters.statusName = null;
      } else {
        this.tableFilters.statusName = statusName;
      }
    },
    alarmPlay() {
      if (this.audio == null) {
        // this.audio = new Audio("/mp3/021008_alarm-clock-trippy-cats-67866.mp3");
        this.audio = new Audio("/mp3/fire-alarm-9677.mp3");
        this.audio.play();
      } else {
        if (this.audio.paused) {
          this.audio.play();
        }
      }
    },
    alarmStop() {
      if (this.audio == null) return;
      if (this.audio.paused) return;
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
    },
    openWorkflowOccurrecesFilledModal(processFilledId, value) {
      this.$refs.WorkflowOccurrecesFilledModal.show(processFilledId, value);
    },
    selectCard(cardId) {
      if (this.selectedCard === cardId) {
        this.selectedCard = null;
      } else {
        this.selectedCard = cardId;
      }
    },
    /* Estilo coluna Status Name */
    classStatusNameColor(item) {
      switch (item.statusName.toUpperCase()) {
        // case "EM VIAGEM":
        case "OK":
          return "table-cell status-ok";

        case "AGUARDANDO ACEITE":
          return "table-cell status-pending";

        case "EM CARREGAMENTO":
          return "table-cell status-blue";

        case "EM ESPERA":
          return "table-cell status-orange";

        case "EM DESCARGA":
          return "table-cell status-orange";

        case "FIM DE VIAGEM":
          return "table-cell status-ok";

        case "INICIO DE VIAGEM":
          return "table-cell status-ok";

        case "PLANO DE VIAGEM":
          return "table-cell status-iddle";

        case "VALIDAÇÃO/LIBERAÇÃO GR":
          return "table-cell status-validation";

        case "SEM CHECKLIST":
          if (this.isChecklistPending(item)) {
            return "table-cell status-problem";
          } else {
            return "table-cell status-pending";
          }
        default:
          return "table-cell status-pending";
      }
    },
    /* Estilo coluna Checklist GRIS padrão */
    ClassChecklistPadraoColor(trip) {
      switch (trip.checklistGrisPadraoStatus.toUpperCase()) {
        case "OK":
          return "table-cell status-cell status-ok";
        case "SEM CHECKLIST":
          if (this.isChecklistPending(trip)) {
            return "table-cell status-cell status-problem";
          } else {
            return "table-cell status-cell status-pending";
          }
        default:
          return "table-cell status-cell status-problem";
      }
    },
    /* Estilo coluna documentação */
    ClassDocumentColor(trip) {
      switch (trip.documentacao.toUpperCase()) {
        case "OK":
          return "table-cell status-ok";
        default:
          return "table-cell status-purple";
      }
    },
    cellsColorAttr(value, key, item) {
      return this.cellColorStyle(item);
    },
    cellColorStyle(item) {
      switch (item.statusName.toUpperCase()) {
        case "VALIDAÇÃO/LIBERAÇÃO GR":
          return {
            style:
              "background-color: #fd5d93 !important; color: white !important",
          };
        default:
          if (this.isChecklistGrisMustAttention(item))
            return {
              style:
                "background-color: #ec5353 !important; color: white !important",
            };
          else return { style: "" };
      }
    },
  },
  watch: {
    calendarDate(newValue) {
      if (newValue != null && newValue != "") {
        this.tableFilters.dataInicio = newValue;
        this.applyFilter();
      } else {
        this.tableFilters.dataInicio = null;
        this.applyFilter();
      }
    },
  },
};
</script>

<style scoped>
.icon_style {
  color: #ec5353;
}

.selected-card {
  border: 3px solid white;
}

.dashboard-indicator {
  background: #627180;
  border-radius: 0.2857rem;
  height: 140px;
  min-width: 100px;
  max-width: 100px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 0px !important;
  margin-right: 5px !important;
  text-align: center;
}

.dashboard-indicator-1 {
  height: 128px;
  width: 115px;
  border-radius: 10px;
  margin: 3px 3px 3px 3px;
}

.dashboard-indicator-2 {
  border-radius: 0.2857rem;
  text-align: center;
  height: 121px;
}

.dashboard-indicator-title {
  /* color: black; */
  font-size: 55px;
  margin-bottom: 0px;
}

.dashboard-indicator-category {
  font-size: 12px;
}

.table-cell {
  padding: 7px 7px 7px 7px;
  margin: -15px -5px -15px -4px;
  text-align: center;
}

.status-blue {
  background-color: #007bff;
  color: white;
}

.status-orange {
  background-color: #ff9021;
  color: white;
}

.status-cell {
  text-align: center;
}

.status-ok {
  background-color: #45a26e;
  color: white;
}

.status-problem {
  background-color: #ec5353;
  color: white;
}

.status-purple {
  background-color: rgba(175, 3, 175, 0.788);
  color: white !important;
}

.status-iddle {
  background-color: #a0a0a0;
  color: black;
}

.status-validation {
  background-color: #fd5d93;
  color: white !important;
}

.status-pending {
  background-color: #df9101;
  color: black;
}

@keyframes transicao-alerta {
  from {
    background-color: #ee6b6e;
  }

  to {
    background-color: #d1001f;
  }
}

.alert-checklist-gris {
  animation: transicao-alerta 1s linear infinite;
  /* background-color: red; */
}

.alert-checklist-gris-title {
  text-align: center;
  color: white;
}

.td-limitado {
  max-width: 250px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.td-limitado:hover {
  overflow: visible !important;
  white-space: initial !important;
}
</style>
